import { AnyAction } from "redux";
import { ThunkDispatch } from "redux-thunk";
import {
  Action,
  AuditStatusReport,
  CamStatusReport
} from "../constants/interfaces";
import api from "../utils/api";

interface State {
  auditStatusReports: AuditStatusReport[];
  camStatusReport: CamStatusReport;
  error: Error | null;
  loading: boolean;
}

export function getInitialState(): State {
  return {
    auditStatusReports: [],
    camStatusReport: {} as CamStatusReport,
    loading: false,
    error: null
  };
}

export const dhbTypes = {
  GET_CAM_STATUS_REPORT_REQUEST: "GET_CAM_STATUS_REPORT_REQUEST",
  GET_CAM_STATUS_REPORT_RESPONSE: "GET_CAM_STATUS_REPORT_RESPONSE"
};

export const dhbActions: any = {
  getCamStatusReport: (id: string) => async (
    dispatch: ThunkDispatch<{}, {}, AnyAction>
  ) => {
    dispatch({ type: dhbTypes.GET_CAM_STATUS_REPORT_REQUEST });
    try {
      const { data: camStatusReport } = await api.get(
        `/audits/getDHBCAMStatusReport/${id}`
      );

      dispatch({
        type: dhbTypes.GET_CAM_STATUS_REPORT_RESPONSE,
        payload: camStatusReport,
        error: false
      });
    } catch (e) {
      dispatch({
        type: dhbTypes.GET_CAM_STATUS_REPORT_RESPONSE,
        payload: e,
        error: true
      });
      return e;
    }
  }
};

export default function dhb(state = getInitialState(), action: Action) {
  const { type, payload, error } = action;

  switch (type) {
    case dhbTypes.GET_CAM_STATUS_REPORT_REQUEST: {
      return { ...state, loading: true, error: null };
    }

    case dhbTypes.GET_CAM_STATUS_REPORT_RESPONSE: {
      if (error) {
        return {
          ...state,
          loading: false,
          error: payload
        };
      }

      return {
        ...state,
        loading: false,
        error: null,
        camStatusReport: payload
      };
    }
  }
  return state;
}
